module.exports = __webpack_public_path__ + "static/media/icomoon.1d1e36bf.woff";